<dt-modal-content (closeClick)="close()" [contentPadding]="false" size="giant">
  <ng-template #title>{{ event.name }}</ng-template>
  <ng-template #content>
    <mat-tab-group dynamicHeight #tabGroup>
      <mat-tab i18n-label label="Metadaten">
        <div class="metadata-container">
          <table [dtOverlayProgress]="metadata == null">
            <h4 class="title" i18n>Abgabeinformationen</h4>
            <tr>
              <td i18n>ID</td>
              <td>{{ metadata?.eventRegistrationId }}</td>
            </tr>
            <tr>
              <td i18n>Freitextlänge</td>
              <td i18n>{{ metadata?.freeTextLength }} Zeichen</td>
            </tr>
            <tr>
              <td i18n>Registrierungsdatum</td>
              <td>{{ metadata?.registrationDate | date: 'medium' }}</td>
            </tr>
            <tr>
              @if (currentParticipantEventRegistration?.submitted) {
                <td i18n>Abgabedatum</td>
              } @else {
                <td i18n>Zuletzt bearbeitet</td>
              }
              <td i18n>{{ metadata?.submissionDate | date: 'medium' }}</td>
            </tr>
            <h4 class="title" i18n>Benutzerinformationen</h4>
            <tr>
              <td i18n>ID</td>
              <td>{{ metadata?.userId }}</td>
            </tr>
            <tr>
              <td i18n>E-Mail</td>
              <td>{{ metadata?.userEmail }}</td>
            </tr>
            <tr>
              <td i18n>Name</td>
              <td
                >{{ metadata?.userName }}
                @if (metadata && !metadata.userName) {
                  <i i18n>Kein Name</i>
                }
              </td>
            </tr>
            <h4 class="title" i18n>Projektinformationen</h4>
            <tr>
              @if (currentParticipantEventRegistration && !currentParticipantEventRegistration.submitted) {
                <td colspan="2">
                  <span i18n>Projektinformationen werden erst nach der Abgabe angezeigt.</span>
                </td>
              }
            </tr>
            @if (currentParticipantEventRegistration?.submitted) {
              <tr>
                <td i18n>Titel</td>
                <td>{{ metadata?.projectName }}</td>
              </tr>
              <tr>
                <td i18n>Version</td>
                <td>{{ metadata?.projectVersion }}</td>
              </tr>
              <tr>
                <td i18n>Größe</td>
                <td>{{ metadata?.projectSize | number: '1.3-3' }}/10MB</td>
              </tr>
              <tr>
                <td i18n>Modus</td>
                <td i18n>Entscheidungsnavi {{ metadata?.projectMode | titlecase }}</td>
              </tr>
              <tr>
                <td i18n>Gesamtzeit</td>
                <td>{{ metadata?.projectTotalTime | number: '1.3-3' }}s</td>
              </tr>
              <tr>
                <td i18n>Aktive Zeit</td>
                <td>{{ metadata?.projectActiveTime | number: '1.3-3' }}s</td>
              </tr>
              <tr>
                <td i18n>Inaktive Zeit</td>
                <td>{{ metadata?.projectTotalTime - metadata?.projectActiveTime | number: '1.3-3' }}s</td>
              </tr>
              <h4 class="title" i18n>Projektfortschritt</h4>
              <tr>
                <td colspan="2">
                  @if (metadata?.projectMode === 'starter' || metadata?.projectMode === 'educational') {
                    <div class="project-progress-container">
                      <ul>
                        <li i18n>Schritt 1: {{ metadata.projectProgress[0] }}</li>
                        <li i18n>Schritt 2: {{ metadata.projectProgress[1] }}</li>
                        <li i18n>Schritt 3: {{ metadata.projectProgress[2] }}</li>
                        <li i18n>Schritt 4: {{ metadata.projectProgress[3] }}</li>
                        @if (metadata.projectMode === 'educational') {
                          <li i18n>Schritt 5: {{ metadata.projectProgress[4] }}</li>
                        }
                      </ul>
                    </div>
                  }
                </td>
              </tr>
            }
          </table>
        </div>
      </mat-tab>

      @if (event.questionnaire?.length > 0) {
        <mat-tab i18n-label label="Fragebogen">
          <div class="questionnaire-tab">
            <dt-questionnaire
              [readonly]="true"
              [questionnairePages]="event.questionnaire"
              [submission]="currentParticipantEventRegistration"
              (openStatus)="tabGroup.selectedIndex = 0"
            ></dt-questionnaire>
          </div>
        </mat-tab>
      }

      @if (event.freeTextConfig.enabled) {
        <mat-tab [label]="event.freeTextConfig.name">
          @if (metadata?.freeTextLength > 0) {
            <dt-rich-text-editor
              [readonly]="true"
              [text]="currentParticipantEventRegistration?.freeText"
              [withToolbar]="false"
            ></dt-rich-text-editor>
          }
          @if (metadata?.freeTextLength === 0) {
            <div class="empty-message" i18n>Es wurde kein Freitext eingegeben</div>
          }
        </mat-tab>
      }
    </mat-tab-group>
  </ng-template>
</dt-modal-content>
